import { render, staticRenderFns } from "./NewBooking.vue?vue&type=template&id=5a5a577a&"
import script from "./NewBooking.vue?vue&type=script&lang=js&"
export * from "./NewBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports